<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        Icon,
        Card,
        Heading,
        Paragraph,
    } from '@smatch/cassiopeia-web-components';

    // COMPONENTS
    import LayoutInside from 'src/app/library/layouts/layout-inside/LayoutInside.svelte';
    import SubscriptionForm from './components/SubscriptionForm.svelte';

    // TYPES
    import type { Subscription } from 'src/app/types';

    // UTILITES
    import { navigate } from 'svelte-navigator';

    /* PROPS ----------------------------------------------------------------------------------- */

    export let subscription: Subscription | undefined = undefined;
    export let action: 'create' | 'update';

    /* INTERNALS ------------------------------------------------------------------------------- */

    const navigateToOverview = (): void => {
        navigate('/subscriptions');
    };

</script>

<LayoutInside>

    <svelte:fragment slot='main'>

        <div class = 's8-header'>
            <Icon
                key = 'arrowLeft'
                css = '!h-5'
                on:click = { navigateToOverview }
            />
            <Heading size = 'lg'>{ `${ action === 'create' ? 'Create' : 'Update' } Subscription` }</Heading>
        </div>

        {#if action === 'create'}
            <Paragraph>
                Tell us what you are looking for, and we will notify you by email as soon as we have deals that
                match your preferences.
            </Paragraph>
        {/if}
        <Card>
            <SubscriptionForm bind:subscription { action } />
        </Card>

    </svelte:fragment>

</LayoutInside>

<style lang='postcss'>
    div.s8-header {
        display: flex;
        align-items: baseline;
        column-gap: 10px;

        :global(> *:last-child) {
            flex-grow: 1;
        }
    }
</style>